import { render, staticRenderFns } from "./ShareRoom.vue?vue&type=template&id=cabf7130&scoped=true"
import script from "./ShareRoom.vue?vue&type=script&lang=js"
export * from "./ShareRoom.vue?vue&type=script&lang=js"
import style0 from "./ShareRoom.vue?vue&type=style&index=0&id=cabf7130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabf7130",
  null
  
)

export default component.exports